export const environment = {
  production: true,
  serverUrl: '/restapi/',
  serverUrlMail: '/formibro/formulario/'
};
